import React, {Fragment} from "react";
import {postData} from "../../../../utils/request";
import {CurrencyFormatter, ProductColumn, productTooltip, UnitFormatter} from "../../../../utils/formatters";
import TextInput from "../../../form/TextInput";
import {ifCompletedInput} from "../../../../utils/other";
import SelectorGrid from "../../../form/SelectorGrid/SelectorGrid";
import Modal from "../../../layout/Modal";

const filterable = true;
const sortable = true;

export default class Items extends React.Component {

    state = {
        itemsToAdd: []
    };

    render() {
        const editableFields = this.props.stateType.Modification(this.props.values.state) ? ["id", "saleprice", "discount", "qty"] : (this.props.stateType.TransferProcessed(this.props.values.state) ? ["saleprice", "discount"] : []);
        return (
            <Fragment>
                <Modal
                    ref={(addItemModal) => this.addItemModal = addItemModal}
                    size="large"
                    header="Termékek"
                    disabled={this.props.disabled || this.props.isLoading}
                    buttons={[
                        {
                            text: "Mégse",
                            props: {
                                color: "default",
                                disabled: this.props.disabled || this.props.isLoading
                            },
                            onClose: true,
                            onClick: async () => {
                                try {
                                    this.setState({itemsToAdd: []});
                                    this.addItemModal && this.addItemModal.hide();
                                } catch (e) {

                                }
                            }
                        },
                        {
                            text: "Hozzáadás",
                            props: {
                                color: "primary",
                                disabled: !this.state.itemsToAdd.length || this.props.disabled || this.props.isLoading
                            },
                            onClick: async () => {
                                try {
                                    this.state.itemsToAdd.length && await this.addNewRows(this.state.itemsToAdd);
                                    this.setState({itemsToAdd: []});
                                    this.addItemModal && this.addItemModal.hide();
                                } catch (e) {

                                }
                            }
                        }
                    ]}
                >
                    <SelectorGrid
                        component="product"
                        onItemUpdate={async (item, oldItem, field) => {
                            if (parseInt(item.qty) > 0) {
                                if (field === "discount") {
                                    item.discount = parseFloat(item.discount);
                                }
                                if (field === "saleprice") {
                                    item.saleprice = parseFloat(item.saleprice);
                                    item.discount = (100 - item.saleprice / item.listprice * 100).toFixed(2);
                                }
                                if (field === "discount") {
                                    item.saleprice = item.listprice - Math.round(item.listprice / 100 * item.discount);
                                }
                                let has = false;
                                const itemsToAdd = this.state.itemsToAdd.map((_item) => {
                                    if (_item.id + "" === item.id) {
                                        has = true;
                                        return item;
                                    } else {
                                        return _item;
                                    }
                                });
                                if (!has) {
                                    itemsToAdd.push(item);
                                }
                                this.setState({itemsToAdd: itemsToAdd.sort((a, b) => a.qty - b.qty)});
                            } else {
                                const itemsToAdd = this.state.itemsToAdd.filter((_item) => {
                                    return _item.id + "" !== item.id;
                                });
                                this.setState({itemsToAdd: itemsToAdd.sort((a, b) => a.qty - b.qty)});
                                delete item.qty;
                            }
                            return item;
                        }}
                        onSort={(field, direction) => {
                            if (field === "qty" && !!this.state.itemsToAdd.length) {
                                return {
                                    expression: "FIELD({{id}}, " + this.state.itemsToAdd.map((item) => item.id).join(", ") + ")",
                                    direction
                                };
                            }
                        }}
                        view={["vat"]}
                        columns={{
                            "displayname": {
                                ...ProductColumn("product_id"),
                                width: 6,
                            },
                            "sku": {
                                header: 'ISBN',
                                width: 2,
                                sortable,
                                filterable
                            },
                            "listprice": {
                                header: 'Fogyasztói ár',
                                width: 2,
                                sortable,
                                filterable,
                                renderer: CurrencyFormatter,
                                className: "currency"
                            },
                            "qty": {
                                header: 'Db',
                                width: 1,
                                sortable,
                                renderer: (value, row) => UnitFormatter((this.state.itemsToAdd.find((item) => row.id + "" === "" + item.id) || {}).qty, row.unit),
                                className: "unit",
                                editor:
                                    (parent) =>
                                        (props, value) =>
                                            <TextInput type="number" name="qty" label={false} focus
                                                       value={value}
                                                       onKeyDown={(e, field, value) => {
                                                           ifCompletedInput(e) && parent.onEditorValueChange(props, value);
                                                       }}
                                                       onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}/>
                            }
                        }}
                    />
                </Modal>
                <SelectorGrid
                    {...this.props.getFieldProps("items")}
                    exports={[{as: "excel", label: "Excel", icon: "far fa-file-excel"}]}
                    view={["id", "name", "qty", "unit", "listprice", "sku", "product_id"]}
                    aggregations={{
                        fields: {
                            "qty": {
                                field: "qty", type: "SUM"
                            },
                            "listprice": {
                                field: "listprice", type: "SUM"
                            },
                            "totallistprice": {
                                field: "totallistprice", type: "SUM"
                            },
                        }
                    }}
                    columns={{
                        "displayname": {
                            ...ProductColumn("product_id"),
                        },
                        "category.name": {
                            header: 'Árutípus',
                            width: 1,
                            sortable,
                            filterable
                        },
                        "sku": {
                            header: 'ISBN',
                            sortable,
                            filterable
                        },
                        "listprice": {
                            header: 'Fogyasztói ár',
                            sortable,
                            filterable,
                            renderer: CurrencyFormatter,
                            className: "currency"
                        },
                        "qty": {
                            header: 'Mennyiség',
                            sortable,
                            filterable,
                            renderer: (value, row) => UnitFormatter(value, row.unit),
                            className: "unit",
                            tooltip: (value, rowData) => { return rowData.instock < rowData.qty - (rowData.reserved || 0) && parseInt(this.props.values.state) < 120 ? "Készlethiány!" : ""},
                            columnClassName: (field, value, rowData) => ({
                                "bold color": rowData.instock < rowData.qty - (rowData.reserved || 0),
                                [rowData.instock < rowData.qty - (rowData.reserved || 0) ? (this.props.values.strict ? "danger" : "warning") : "success"]: ["100","110"].indexOf(this.props.values.state + "") !== -1
                            }),
                            editor:
                                (parent) =>
                                    (props, value) => editableFields.indexOf("qty") !== -1 ?
                                        <TextInput type="number" name="qty" label={false} focus value={value}
                                                   onKeyDown={(e, field, value) => {ifCompletedInput(e) && parent.onEditorValueChange(props, value);}}
                                                   onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}/> : false
                        },
                        "totallistprice": {
                            header: 'Összesen',
                            sortable,
                            filterable,
                            renderer: CurrencyFormatter,
                            className: "currency"
                        },
                        ...(["410", "420"].indexOf(this.props.values.state + "") !== -1 ? {
                            "receivedqty": {
                                header: 'Beérkezett',
                                width: 1,
                                sortable,
                                filterable,
                                columnClassName: (field, value, rowData) => ({
                                    "danger color": (parseInt(rowData.receivedqty || 0) - parseInt(rowData.qty || 0)) < 0,
                                    "warning color": (parseInt(rowData.receivedqty || 0) - parseInt(rowData.qty || 0)) > 0,
                                }),
                                renderer: (value, row) => UnitFormatter(value || 0, row.unit),
                                className: "unit"
                            },
                        } : {}),
                        ...(this.props.values.state < 120 ? {
                            "reserved": {
                                header: 'Lefoglalva',
                                width: 1,
                                sortable,
                                filterable,
                                renderer: (value, row) => UnitFormatter(value || 0, row.unit),
                                className: "unit"
                            },
                            "instock": {
                                header: 'Készlet',
                                width: 1,
                                sortable,
                                filterable,
                                renderer: (value, row) => UnitFormatter(value || 0, row.unit),
                                className: "unit"
                            }
                        } : {})
                    }}
                    onItemUpdate={async (item, oldItem, field, rowIndex, {listfieldComponentConfig}) => {
                        if (field === "discount") {
                            item.discount = parseFloat(item.discount);
                        }
                        if (field === "saleprice") {
                            item.saleprice = parseFloat(item.saleprice);
                            item.discount = (100 - item.saleprice / item.listprice * 100).toFixed(2);
                        }
                        if (field === "discount") {
                            item.saleprice = item.listprice - Math.round(item.listprice / 100 * item.discount);
                        }
                        const updateItem = {};
                        Object.keys(listfieldComponentConfig.fielddefs).map((key) => {
                            updateItem[key] = item[key];
                        });
                        let actionparams = {
                            parentcomponent: this.props.componentConfig.componentname,
                            listfield: "items",
                            parentid: this.props.values[this.props.componentConfig.idfield],
                            action: "componentlist.updateItems",
                            items: [updateItem]
                        };
                        await postData(actionparams);
                        return true;
                    }}
                    {...(editableFields.indexOf("id") === -1 ? {listfield: "items"} : {name: "items"})}
                    data={this.props.values}
                    onAddRows={(items) => {
                        return items.map((item) => {
                            item.product_id = item.id;
                            item.saleprice = item.saleprice !== undefined ? item.saleprice : item.listprice;
                            item.qty = item.qty || 1;
                            return item;
                        });
                    }}
                    addRowFunction={({event, addNewRows}) => {
                        this.addNewRows = addNewRows;
                        this.addItemModal && this.addItemModal.focus();
                    }}
                    orderBy={{field: "name", direction: "ASC"}}
                    componentConfig={this.props.componentConfig}
                />
            </Fragment>
        );
    }
}